module.exports = __webpack_public_path__ + "img/pauli-x-root-dagger-2.0c74aaed.svg";